import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

const UnAuth = ({component:Component})=>{
    const auth = localStorage.getItem("auth")
    
    return auth !== "admin"? <Component /> : <Navigate to="/dashboard/" />
}
export default UnAuth